<template>
  <div class="paomadeng-page">
    <div class="filter-bar">
      <div class="filter-select" @click="showDatePopup = !showDatePopup">
        <span>{{ dateLabel }}</span>
        <van-icon :name="showDatePopup ? 'arrow-up' : 'arrow-down'" />
      </div>
      <div class="filter-search">
        <input type="text" v-model="searchKeyword" placeholder="搜索" @keyup.enter="handleSearch" />
        <van-icon name="search" @click="handleSearch" />
      </div>
    </div>

    <div class="filter-popup" v-if="showDatePopup" @click.self="showDatePopup = false">
      <div class="popup-content date-popup">
        <div class="date-grid">
          <div class="date-item" :class="{ active: tempDateFilter === 'today' }" @click="tempDateFilter = 'today'">今日</div>
          <div class="date-item" :class="{ active: tempDateFilter === 'yesterday' }" @click="tempDateFilter = 'yesterday'">昨日</div>
          <div class="date-item" :class="{ active: tempDateFilter === 'week' }" @click="tempDateFilter = 'week'">本周</div>
          <div class="date-item" :class="{ active: tempDateFilter === 'lastWeek' }" @click="tempDateFilter = 'lastWeek'">上周</div>
          <div class="date-item" :class="{ active: tempDateFilter === 'month' }" @click="tempDateFilter = 'month'">本月</div>
          <div class="date-item" :class="{ active: tempDateFilter === 'lastMonth' }" @click="tempDateFilter = 'lastMonth'">上月</div>
          <div class="date-item all-item" :class="{ active: tempDateFilter === '' }" @click="tempDateFilter = ''">全部</div>
        </div>
        <div class="popup-btns">
          <div class="btn-cancel" @click="showDatePopup = false">取消</div>
          <div class="btn-confirm" @click="dateFilter = tempDateFilter; showDatePopup = false">确认</div>
        </div>
      </div>
    </div>

    <div class="notice-list-wrap">
      <div class="loading-mask" v-if="loading">加载中...</div>
      <div class="notice-list">
      <div class="notice-item" v-for="item in filteredList" :key="item.id" @click="openDetail(item)">
        <div class="notice-icon">
          <img src="/static/newImg/index/icon_dt_pmd.webp" style="width:0.5rem;height:0.5rem" />
        </div>
        <div class="notice-info">
          <div class="notice-title" v-html="highlightSearch(item.name)"></div>
          <div class="notice-time">{{ formatTime(item.created_at) }}</div>
        </div>
        <van-icon name="arrow" class="arrow-icon" />
      </div>
      <div v-if="!loading && !filteredList.length" class="empty-tip">暂无内容</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'noticePaomadeng',
  props: {
    cateid: {
      type: Number,
      default: 11
    }
  },
  data() {
    return {
      loading: false,
      showDatePopup: false,
      dateFilter: '',
      tempDateFilter: '',
      searchKeyword: '',
      noticeList: []
    }
  },
  computed: {
    dateLabel() {
      const map = { today: '今日', yesterday: '昨日', week: '本周', lastWeek: '上周', month: '本月', lastMonth: '上月', '': '全部' };
      return map[this.dateFilter] || '全部';
    },
    filteredList() {
      let list = this.noticeList;
      if (this.searchKeyword.trim()) {
        const kw = this.searchKeyword.trim().toLowerCase();
        list = list.filter(i => (i.name || '').toLowerCase().indexOf(kw) > -1);
      }
      if (this.dateFilter && this.dateFilter !== '') {
        list = list.filter(i => this.matchDate(i.created_at, this.dateFilter));
      }
      return list;
    }
  },
  created() {
    this.loadList();
  },
  methods: {
    loadList() {
      const that = this;
      that.loading = true;
      that.$apiFun.post('/api/articlelist', { cateid: that.cateid, page: 1, limit: 100 }).then(res => {
        that.loading = false;
        if (res.code === 200) {
          that.noticeList = res.data.list || [];
        }
      }).catch(() => { that.loading = false; });
    },
    formatTime(t) {
      if (!t) return '';
      const d = new Date(t.replace ? t.replace(/-/g, '/') : t);
      if (isNaN(d.getTime())) return t;
      const p = n => n < 10 ? '0' + n : n;
      return d.getFullYear() + '/' + p(d.getMonth()+1) + '/' + p(d.getDate()) + ' ' + p(d.getHours()) + ':' + p(d.getMinutes()) + ':' + p(d.getSeconds());
    },
    matchDate(t, type) {
      if (!t) return false;
      const d = new Date(t.replace ? t.replace(/-/g, '/') : t).getTime();
      if (isNaN(d)) return false;
      const now = new Date();
      const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
      const inDay = (dayOffset) => d >= (todayStart + dayOffset * 86400000) && d < (todayStart + (dayOffset + 1) * 86400000);
      const getWeekStart = (weekOffset) => {
        const n = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        const day = n.getDay() === 0 ? 6 : n.getDay() - 1;
        n.setDate(n.getDate() - day + weekOffset * 7);
        return n.getTime();
      };
      switch (type) {
        case 'today': return inDay(0);
        case 'yesterday': return inDay(-1);
        case 'week': return d >= getWeekStart(0) && d < getWeekStart(1);
        case 'lastWeek': return d >= getWeekStart(-1) && d < getWeekStart(0);
        case 'month': {
          const s = new Date(now.getFullYear(), now.getMonth(), 1).getTime();
          const e = new Date(now.getFullYear(), now.getMonth() + 1, 1).getTime();
          return d >= s && d < e;
        }
        case 'lastMonth': {
          const s = new Date(now.getFullYear(), now.getMonth() - 1, 1).getTime();
          const e = new Date(now.getFullYear(), now.getMonth(), 1).getTime();
          return d >= s && d < e;
        }
        default: return true;
      }
    },
    highlightSearch(text) {
      const kw = (this.searchKeyword || '').trim();
      if (!kw) return text;
      const safe = (text || '').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      try {
        const reg = new RegExp('(' + kw.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'gi');
        return safe.replace(reg, '<span style="color:#DFB372">$1</span>');
      } catch (e) {
        return safe;
      }
    },
    handleSearch() {},
    openDetail(item) {
      this.$router.push({ path: '/noticeDetail', query: { id: item.id, cateid: 11 } });
    }
  }
}
</script>

<style lang="scss" scoped>
.paomadeng-page {
  padding: 0.3rem;
  color: #fff;
}
.filter-bar {
  display: flex;
  gap: 0.2rem;
  margin-bottom: 0.3rem;
  .filter-select {
    display: flex;
    align-items: center;
    gap: 0.1rem;
    padding: 0.15rem 0.3rem;
    background: #292A2C;
    border-radius: 0.1rem;
    font-size: 0.26rem;
    color: #666;
    .van-icon { color: #666; }
  }
  .filter-search {
    flex: 1;
    display: flex;
    align-items: center;
    background: #292A2C;
    border-radius: 0.1rem;
    padding: 0.15rem 0.3rem;
    input {
      flex: 1;
      background: transparent;
      border: none;
      outline: none;
      color: #fff;
      font-size: 0.26rem;
      &::placeholder { color: #666; }
    }
    .van-icon { color: #DFB372; margin-left: 0.1rem; }
  }
}
.filter-popup {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  z-index: 999;
  .popup-content {
    position: absolute;
    background: #292A2C;
    border-radius: 0.15rem;
    padding: 0.3rem;
  }
  .date-popup {
    position: absolute;
    top: 3.5rem;
    left: 0.3rem;
    width: 94%;
    min-width: unset;
    padding: 0;
    .date-grid {
      display: flex;
      flex-wrap: wrap;
      padding: 0.2rem;
      gap: 0.15rem;
      .date-item {
        width: calc((100% - 0.3rem) / 3);
        flex: none;
        box-sizing: border-box;
        text-align: center;
        padding: 0.25rem 0;
        font-size: 0.35rem;
        color: #fff;
        border: 1px solid #3B3C3D;
        border-radius: 0.1rem;
        &.active {
          color: #DFB372;
          border-color: #DFB372;
        }
        &.all-item {
          color: #DFB372;
          border-color: #DFB372;
        }
      }
    }
    .popup-btns {
      display: flex;
      gap: 0.2rem;
      padding: 0.2rem;
      .btn-cancel, .btn-confirm {
        flex: 1;
        text-align: center;
        padding: 0.25rem 0;
        border-radius: 0.1rem;
        font-size: 0.35rem;
      }
      .btn-cancel { color: #DFB372; border: 1px solid #DFB372; }
      .btn-confirm { background: #DFB372; color: #1E1F24; }
    }
  }
}
.notice-list-wrap {
  position: relative;
  .loading-mask {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,0.01);
    z-index: 99;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #DFB372;
    font-size: 0.3rem;
    pointer-events: none;
  }
}
.notice-list {
  .notice-item {
    display: flex;
    align-items: center;
    padding: 0.25rem;
    background: #292A2C;
    border-radius: 0.15rem;
    margin-bottom: 0.2rem;
    .notice-icon { margin-right: 0.2rem; }
    .notice-info {
      flex: 1;
      .notice-title { font-size: 0.26rem; color: #DFB372; margin-bottom: 0.05rem; line-height: 1.5; }
      .notice-time { font-size: 0.22rem; color: #666; }
    }
    .arrow-icon { color: #666; }
  }
  .empty-tip { text-align: center; color: #666; font-size: 0.3rem; padding: 1rem 0; }
}
</style>



// WEBPACK FOOTER //
// src/components/view/notice/paomadeng.vue